import { FC } from 'react';
import { CheckBoxProps } from './CheckBox.types';
import { StyledCheckBoxDiv } from './CheckBox.styles';
import { Icon } from '../Icon';
import { checkboxVariation } from '../../constants/ApplicationConstants';

export const CheckBox: FC<CheckBoxProps> = ({
  className,
  checkboxId,
  checkboxName,
  checkboxLabel,
  checked,
  children,
  value,
  inputClassName,
  onChange,
  onKeyDown,
  disabled = false,
  iconClassName,
  variation = 'simple',
  ariaLabel,
  ...props
}) => {
  return (
    // Minimum Attributes Required on checkbox are:
    // id, name, onChange, Checked, value, className
    // two types of chekcboxes: simple and switch. If we don't pass variation prop, by default, simple checkbox will be rendered.
    <StyledCheckBoxDiv
      className={className}
      data-component-name="a-ui-library-CheckBox"
      data-testid="ui-library-CheckBox"
    >
      {variation === checkboxVariation.SIMPLE ? (
        <>
          <input
            type="checkbox"
            id={checkboxId}
            name={checkboxName}
            onChange={onChange}
            onKeyDown={onKeyDown}
            checked={checked}
            value={value}
            className={inputClassName}
            aria-checked={checked}
            disabled={disabled}
            {...props}
          ></input>
          <label htmlFor={checkboxId}>
            {iconClassName ? <Icon iconClass={`${iconClassName} pr-1`} /> : ''}
            {checkboxLabel || (ariaLabel && <span className="sr-only">{ariaLabel}</span>)}
            {children}
          </label>
        </>
      ) : (
        <label className="checkbox-switch-wrapper" htmlFor={checkboxId} tabIndex={-1}>
          <span
            className="checkbox-switch"
            tabIndex={0}
            onKeyDown={onKeyDown}
            onChange={onChange}
            role="switch"
            aria-checked={checked}
          >
            <input
              type="checkbox"
              id={checkboxId}
              name={checkboxName}
              checked={checked}
              onChange={onChange}
              value={value}
              data-testid="checkbox"
              {...props}
              className={inputClassName}
              tabIndex={-1}
              role="switch"
              aria-checked={checked}
              aria-label={ariaLabel}
            />
            <span className="checkbox-slider" tabIndex={-1}></span>
          </span>
          {children}
        </label>
      )}
    </StyledCheckBoxDiv>
  );
};
